export const cookieBanner = {
  Header: "The healthiest cookies you'll choose today",
  Body: "Our website uses cookies to collect useful information that lets us and our partners support basic functionality, analyze visitor traffic, deliver a better user experience, and provide ads tailored to your interests. Agreeing to the use of cookies is your choice.",
  LearnMore: "Learn more",
  DeclineButton: "Decline cookies",
  AcceptButton: "Accept cookies",
} as const;
